// ProductStage.js
import React from 'react';
import DOMPurify from 'dompurify';

const ProductStage = ({ imageUrl = '', topline  = '', headline = '', additionalCss = '', Subheadlines  = []}) => (
  <div className={`c-stage c-stage--reduced-height ${additionalCss}`}>
      <div className="c-stage__wrapper">
          <div className="l-grid l-grid--max-width u-hidden-small-down">
              <div className="l-grid__row">
                  <div className="l-grid__column-12">
                  </div>
              </div>
          </div>

          <div className="c-stage__image-container">
              <picture className="c-image c-stage__image">
                  <img src={imageUrl} className="c-image__img" alt={headline} />
              </picture>
          </div>

          <div className="l-grid l-grid--max-width c-stage__content">
              <div className="l-grid__row c-stage__content__grid">
                  <div className="l-grid__column-large-8 offset-large-2 ">
                      <h4 className="c-heading c-stage__topline"
                          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(topline) }}>
                        </h4>
                  </div>
                  <div className="l-grid__column-large-10 offset-large-1 ">
                      <h1 className="c-heading c-heading--bold-cap" id="headline-8F23532F2DF342BA8B52146225186C29"
                        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(headline) }}>
                      </h1>
                  </div>
                  <div className="l-grid__column-medium-10 offset-medium-1 l-grid__column-large-8 offset-large-2">
                      <ul className="c-list c-stage__list">
                        {Subheadlines.map((subheadline, index) => (
                          <li key={index} className="c-list__item c-list__item--icon ">
                            {subheadline.text}
                          </li>
                        ))}
                      </ul>
                  </div>
              </div>
          </div>
      </div>
  </div>
);

export default ProductStage;
